/*
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// MOBILE
import isMobile from 'is-mobile-with-ipad';

import Scaleable from '../gfx/Scaleable';

import * as Textures from '../textures/Textures';
import Hands from '../../public/model/arhands.fbx';

export default class ARHands extends Scaleable {
  constructor(props) {
    super(props);
    this.setup(props);
  }

  setup = props => {
    this.setupProperties(props);
    this.setupCamera();
    this.setupScene();
    this.setupMesh();
    this.setupLights();
  };

  setupProperties = props => {
    this.props = props;
    this.renderer = this.props.renderer;
    this.bindFbo = this.props.bindFbo;
    this.unbindFbo = this.props.unbindFbo;
    this.mixers = [];
  };

  setupCamera = () => {
    let size = this.renderer.getDrawingBufferSize();
    let aspect = size.width / size.height;
    this.camera = new THREE.PerspectiveCamera(45, aspect, 1, 1000);
    this.camera.position.z = 15;
  };

  setupScene = () => {
    this.scene = new THREE.Scene();
  };

  setupMesh = () => {
    let loader = new THREE.FBXLoader();
    loader.parse;
    let object = loader.parse(Hands);

    let bindedFboToChild = false;
    object.traverse(child => {
      if (child.type == 'Mesh') {
        if (!bindedFboToChild) {
          child.onBeforeRender = () => {
            this.bindFbo();
          };
          bindedFboToChild = true;
        }

        child.castShadow = true;
        child.receiveShadow = true;

        child.material[0] = new THREE.MeshToonMaterial({
          map: Textures.Hands,
          color: 0x6bc4ff,
        });

        child.material[1] = new THREE.MeshToonMaterial({
          map: Textures.Hands,
        });

        child.material[2] = new THREE.MeshToonMaterial({
          map: Textures.Hands,
        });
        // child.material.forEach(mat => {
        //   mat.map = Textures.Hands;
        //   mat.color = new THREE.Color(0xffffff);
        // });
      }
    });
    object.mixer = new THREE.AnimationMixer(object);
    this.mixers.push(object.mixer);
    var action = object.mixer.clipAction(object.animations[0]);
    action.play();

    let scale = 0.05;
    object.scale.set(-scale, scale, scale);
    object.rotation.set(-Math.PI / 2.0 - Math.PI / 4.0, 0, 0);
    object.position.set(0, 2.75, 0);
    object.updateMatrixWorld(true);
    this.add(object);
    this.scene.add(this);
  };

  setupLights = () => {
    let light = new THREE.DirectionalLight(0xffffff, 0.4);
    light.position.set(-0.25, 2.0, 2.0);
    light.lookAt(0.0, 0.0, 0.0);
    this.scene.add(light);

    let side = new THREE.DirectionalLight(0xffffff, 0.4);
    side.position.set(-1.0, 2.75, 0);
    side.lookAt(0.0, 0.0, 0.0);
    this.scene.add(side);

    let spotLight0 = new THREE.SpotLight(0xffffff);
    spotLight0.intensity = 0.5;
    spotLight0.position.set(-0.25, 2.75, 2.0);
    spotLight0.lookAt(0.0, 2.75, 0.0);
    spotLight0.castShadow = true;
    let shadowSize = 4096;
    if (isMobile()) {
      shadowSize /= 2;
    }
    spotLight0.shadow.mapSize.width = shadowSize;
    spotLight0.shadow.mapSize.height = shadowSize;
    spotLight0.shadow.camera.near = 0.1;
    spotLight0.shadow.camera.far = 100;
    spotLight0.shadow.camera.fov = 45;
    this.scene.add(spotLight0);
  };

  update = (time, delta) => {
    if (this.visible) {
      for (var i = 0; i < this.mixers.length; i++) {
        this.mixers[i].update(delta / 1000.0);
      }
    }
  };

  render = () => {
    if (this.visible) {
      this.renderer.render(this.scene, this.camera);
    }
  };

  resize = () => {
    this.setupCamera();
  };
}



// WEBPACK FOOTER //
// ./src/ar/ARHands.js